import React from 'react';
import { Box, Grid } from '@mui/material';
import {
  SparkDynamicOutput,
  SparkGenerateOutput,
  SparkTabs,
} from 'sharedComponents/UI';
import SparkTaskAccordion from './SparkTaskAccordion';
import { useSparkRunTaskByRunID } from 'hooks/SparkRuns';
import { useSparkTaskStatuses } from 'hooks/EntityTypes/useSparkTaskStatuses';
import HistoryCardSkeleton from 'sharedComponents/Skeleton/HistoryCardSkeleton';
import NodeSpecificOutput from 'components/CreateSpark/SparkBuilderDrawers/RightDrawer/forms/TestAccordion/NodeSpecificOutput';
import { useBoardNodeTypes } from 'hooks/EntityTypes/useBoardNodeTypes';

type TaskDetailsTabProps = {
  sparkRunID: string;
};

function TaskDetailsTab({ sparkRunID }: TaskDetailsTabProps) {
  const [outputError, setOutputError] = React.useState('');
  const { idMap: sparkTaskIdMap } = useSparkTaskStatuses();
  const { joinedRunTasks, isLoading, promptFunctionByStepID } =
    useSparkRunTaskByRunID(sparkRunID);

  const { idMap, isLoading: isLoadingBoardNodes } = useBoardNodeTypes();

  if (isLoading || isLoadingBoardNodes) {
    return <HistoryCardSkeleton count={10} />;
  }
  return (
    <Grid container gap={2}>
      {joinedRunTasks?.map((sparkTask) => {
        const promptFunction =
          promptFunctionByStepID?.[sparkTask?.sparkStep?.id + ''];
        console.log(promptFunction, 'promptFUnctions');
        const outputTypeID = promptFunction?.attributes.outputBoardNodeTypeID;
        const outputType = idMap?.[outputTypeID + ''];
        return (
          <SparkTaskAccordion
            joinedRunTask={sparkTask}
            sparkTaskIdMap={sparkTaskIdMap}
            key={sparkTask.id}
          >
            <Box px={3} py={2} width='100%'>
              <SparkTabs
                tabItems={[
                  {
                    label: 'Input',
                    content: (
                      <SparkGenerateOutput
                        output={JSON.parse(sparkTask.attributes.input)}
                      />
                    ),
                  },
                  {
                    label: 'Output',
                    content: (
                      <Grid container gap={2}>
                        {outputError ? (
                          <SparkDynamicOutput
                            output={sparkTask.attributes.output || ''}
                          />
                        ) : (
                          <NodeSpecificOutput
                            nodeType={outputType}
                            output={sparkTask.attributes.output || ''}
                            onError={(message) => {
                              setOutputError(message);
                            }}
                          />
                        )}
                      </Grid>
                    ),
                  },
                ]}
              />
            </Box>
          </SparkTaskAccordion>
        );
      })}
    </Grid>
  );
}

export default TaskDetailsTab;
